// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Xeo_","footer":"ModalCreateQualiphyProcedure_footer__qm2Z8","additionData":"ModalCreateQualiphyProcedure_additionData__19_M_"};